export const REQUIRED = "Can't be blank";
export const INCORRECT_FORMAT = 'Is not in correct format';
export const NUMBER = 'Should be a number';
export const POSITIVE = "Can't be negative";
export const MAXIMUM = "Can't be more than 100";
export const INTEGER = "Can't be decimal ";
